<template>
  <div>
    <button @click="getGeoCode">解析地址(返回英文)</button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  methods: {
    async getGeoCode() {
      // 配置参数
      const apiKey = 'AIzaSyCfkLLedmg_KziDyyt4k6CSllo-_c9ORL8'
      const address = '40.714224,-73.961452' // 任意中文/英文地址

      try {
        const res = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
          params: {
            latlng: address,
            key: apiKey,
            language: 'en' // 关键：强制返回英文
          }
        })

        console.log('英文解析结果：', res.data)
        // 取格式化英文地址
        const englishAddress = res.data.results[0]?.formatted_address
        console.log('英文完整地址：', englishAddress)

      } catch (error) {
        console.error('请求失败：', error)
      }
    }
  }
}
</script>